import { Activity } from '@app/core/models';
import { isPast } from 'date-fns';
import { head, isEmpty } from 'lodash';

export enum AnswerStatus {
  Teacher,
  Send,
  Late,
  Waiting,
  Completed,
  Evaluated,
}

function pastDate(date?: string | null): boolean {
  if (!date) {
    return true;
  }
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) {
    return true;
  }
  return isPast(parsed);
}

const ANSWERS_STATUS = [
  {
    status: AnswerStatus.Send,
    label: 'eclass.aula.subir-resposta',
    compare: (activity: Activity) => {
      const answers = head(activity?.answers);
      const limitDate = !(activity.limit && pastDate(String(activity.date_end)));
      const send = isEmpty(answers) && limitDate;
      const resend = !pastDate(answers?.resubmission_date);
      return send || resend;
    },
  },
  {
    status: AnswerStatus.Evaluated,
    label: 'eclass.tarefa.correcao-concluida',
    compare: (activity: Activity) => {
      const answers = head(activity?.answers);
      const evaluative = activity?.evaluative;
      return !!answers?.revised && evaluative;
    },
  },
  {
    status: AnswerStatus.Completed,
    label: 'eclass.tarefa.ver-resposta',
    compare: (activity: Activity) => {
      const answers = head(activity?.answers);
      const notEvaluative = !activity?.evaluative && !answers?.resubmission_date;
      return !!answers && (!!answers?.revised || notEvaluative);
    },
  },
  {
    status: AnswerStatus.Waiting,
    label: 'eclass.tarefa.aguardando-correcao',
    compare: (activity: Activity) => {
      const answers = head(activity?.answers);
      return !isEmpty(answers) && !answers?.resubmission_date;
    },
  },
  {
    status: AnswerStatus.Late,
    label: 'eclass.aula.subir-resposta',
    compare: () => true,
  },
];

export function answerStatus(activity: Activity): any {
  return ANSWERS_STATUS.find((status) => status.compare(activity));
}
